"use client";
import { useEffect, useState } from "react";
import GroupFilter from "../components/GroupFilter";

type Contributor = {
  requestId: string;
  name: string;
  mobile: string;
  amount: string;
  packNo: string;
  groupMode: string;
  groupCode: string;
  groupName: string;
  status: string;
};

export default function ContributorsTable() {
  const [contributors, setContributors] = useState<Contributor[]>([]);
  const [selectedGroupMode, setSelectedGroupMode] = useState("");
  const [selectedGroupCode, setSelectedGroupCode] = useState("");
  const [selectedGroupName, setSelectedGroupName] = useState("");

  useEffect(() => {
    const fetchContributors = async () => {
      try {
        const res = await fetch("/api/contributors");
        const data = await res.json();

        const formatted: Contributor[] = (data.details || [])
          .filter((item: any) => item.status === "approved")
          .map((item: any) => ({
            requestId: item.requestID ?? `${item.mobile}-${Date.now()}`,
            mobile: item.mobile ?? "",
            name: item.name ?? "Unknown",
            groupCode: item.groupCode ?? "UNKNOWN",
            groupMode: item.groupMode ?? "N/A",
            groupName: item.groupName ?? "N/A",
            amount: item.amount ?? "N/A",
            packNo: item.packNo ?? "",
            status: item.status ?? "",
          }));

        setContributors(formatted);
      } catch (err) {
        console.error("Error fetching contributors:", err);
      }
    };

    fetchContributors();
  }, []);

  // ✅ Corrected filter logic
  const filteredContributors = contributors.filter(item => {
    return (
      (!selectedGroupMode || item.groupMode === selectedGroupMode) &&
      (!selectedGroupCode || item.groupCode === selectedGroupCode) &&
      (!selectedGroupName || item.groupName === selectedGroupName)
    );
  });

  return (
    <div>
      <h2>Assign Pack Numbers</h2>

      {/* Group filter dropdowns */}
      <GroupFilter
        groupMode={selectedGroupMode}
        setGroupMode={setSelectedGroupMode}
        groupCode={selectedGroupCode}
        setGroupCode={setSelectedGroupCode}
        rows={contributors}
      />

      {/* Optional: Group Name filter */}
      <select
        value={selectedGroupName}
        onChange={e => setSelectedGroupName(e.target.value)}
      >
        <option value="">All Group Names</option>
        {Array.from(new Set(contributors.map(c => c.groupName))).map(name => (
          <option key={name} value={name}>
            {name}
          </option>
        ))}
      </select>

      {/* Table */}
      <table border={1} cellPadding={8} style={{ marginTop: 20 }}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Mobile</th>
            <th>Amount</th>
            <th>Pack No</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredContributors.map(c => (
            <tr key={c.requestId}>
              <td>{c.name}</td>
              <td>{c.mobile}</td>
              <td>{c.amount}</td>
              <td>{c.packNo}</td>
              <td>
                <button onClick={() => console.log("Edit", c)}>
                  Edit
                </button>
              </td>
            </tr>
          ))}
          {filteredContributors.length === 0 && (
            <tr>
              <td colSpan={5}>No records found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
